import { IApplicationState } from '../../types/redux';

export function selectAddressText(state: IApplicationState) {
  const { dealType } = state.page;
  const data = state.estimation[dealType].data;

  if (data) {
    const { mobileAddress, desktopAddress } = data;

    return { mobileAddress, desktopAddress };
  }

  return { desktopAddress: undefined, mobileAddress: undefined };
}
